const config = {
    apiKey: "AIzaSyCV-Rv-j2JuCDa_CS5PDqyYmw8YzV9WijA",
    authDomain: "lockscreen-eb764.firebaseapp.com",
    databaseURL: "https://lockscreen-eb764.firebaseio.com",
    projectId: "lockscreen-eb764",
    storageBucket: "lockscreen-eb764.appspot.com",
    messagingSenderId: "493062227028",
    appId: "1:493062227028:web:6134eed5a270b7153819c1"
};

export default config;